// extracted by mini-css-extract-plugin
export default {"syncable":"_-web-client-js-react-components-___syncedInputs-module__syncable___7IGW+"};